export default __webpack_public_path__ + "static/learn-cover3-eae86a1dd34a94b4f3cc3bf526722f85.jpg";